<template>
 <div>
    <!--<Modal v-model="$parent.cityListDialog" :mask-closable="false">-->
        <div slot="header"><strong style="font-size: 16px">City ({{cityArr.length}})</strong>
        <Icon type="md-add-circle" style="float: right" size="22" @click="onAddCity()"></Icon>
        </div>
        <div>
         <Table :columns="cityHeaders" :data="cityArr" ref="cityTable" :highlight-row="true"
                @on-row-click="emitCity" max-height="400">
             <template slot-scope="{ row }" slot="action">
                 <Icon type="md-create" @click="onEditCity(row)"></Icon>&nbsp;
                 <Icon type="md-close" @click="onDeleteCity(row.id)"></Icon>
             </template>
         </Table>
        </div>
        <!--<div slot="footer">-->
        <!--<Button style="background: #999999; color: white;font-weight: bolder" @click="$parent.cityListDialog=false">CLOSE</Button>-->
        <!--</div>-->
    <!--</Modal>-->

     <Modal v-model="addCityDialog" :mask-closable="false" width="450" draggable>
         <div slot="header"><strong>{{editMode?'Edit':'New'}} City</strong></div>
         <div>
             <Form :model="cityForm" :rules="ruleCityForm" ref="cityForm" :label-width="95">
                 <FormItem prop="city" label="City">
                     <Input v-model="cityForm.city"/>
                 </FormItem>

                 <FormItem prop="shortCode" label="City Code">
                     <Input v-model="cityForm.shortCode" :maxlength="3" class="code-uppercase"/>
                 </FormItem>

                 <FormItem prop="state" label="State">
                     <Input v-model="cityForm.state"/>
                 </FormItem>

                 <FormItem prop="country" label="Country">
                     <Input v-model="cityForm.country"/>
                 </FormItem>
             </Form>
         </div>
         <div slot="footer">
             <Button v-if="!editMode" type="primary" style="font-weight: bolder" @click="addCity" :loading="loading">
                 <span v-if="!loading">SAVE</span>
                 <span v-else>Loading...</span>
             </Button>
             <Button v-if="editMode" type="primary" style="font-weight: bolder" @click="modifyCity">UPDATE</Button>
             <Button style="background: #999999; color: white;font-weight: bolder" @click="addCityDialog=false">CANCEL</Button>
         </div>
     </Modal>
 </div>
</template>

<script>
import {ADD_CITY, UPDATE_CITY, DELETE_CITY} from '../../graphql/mutations/city'
import {GET_CITIES} from '../../graphql/queries/city'
import {SUBSCRIBE_GET_CITIES} from '../../graphql/subscription/city'
import {generateUUID} from '../../Constants/Constant'
import ValidationRules from '../../Constants/ValidationRules'

export default {
    apollo: {
        city: {
            query: GET_CITIES,
            subscribeToMore: {
                document: SUBSCRIBE_GET_CITIES,
                updateQuery: function(previousResult, { subscriptionData }) {
                    this.cityArr = subscriptionData.data.city;
                },
            },
            result ({ data, loading }) {
                if (!loading) {
                    this.cityArr = data.city;
                }
            }
        }
    },
 name: "City",
 data: function(){
    return{
       mutation_ADD_CITY: ADD_CITY,
       mutation_UPDATE_CITY: UPDATE_CITY,
       mutation_DELETE_CITY: DELETE_CITY,
       cityArr: [],
       cityHeaders: [
        {title: 'City', key: 'city'},
        {title: 'Code', key: 'shortCode'},
        {title: 'State', key: 'state'},
        {title: 'Country', key: 'country'},
        {title: ' ', slot: 'action'}
       ],
       addCityDialog: false,
       cityForm:{
         id: '',
         city: '',
         shortCode: '',
         state: '',
         country: 'India'
       },
        ruleCityForm:{
         city: ValidationRules.textField('City'),
         shortCode: ValidationRules.cityCode,
         state: ValidationRules.textField('State'),
         country: ValidationRules.textField('Country'),
     },
       editMode: false,
       loading: false
    }
  },
 methods:{
    emitCity(row, index){
        this.$emit('city', row)
    },
    reset: function(){
        this.$refs['cityForm'].resetFields();
    },
    onAddCity(){
        this.reset();
        this.editMode = false;
        this.addCityDialog = true;
    },
    addCity(){
        this.loading = true;
        this.$refs['cityForm'].validate((valid) => {
            if (valid) {
                this.insertCity();
            }else{
                this.loading = false
            }
        })
    },
   async insertCity(){
       let self = this;
       this.$apollo.mutate({
           mutation: this.mutation_ADD_CITY,
           variables: {
               id: generateUUID(),
               city: this.cityForm.city,
               shortCode: this.cityForm.shortCode.toUpperCase(),
               state: this.cityForm.state,
               country: this.cityForm.country
           }
       }).then(function(response){
           self.$Message.success('New City added successfully!');
           self.reset();
           self.loading = false
           self.addCityDialog = false;
       }).catch(function(err){
           if(err.networkError.result.errors && err.networkError.result.errors.length){
               self.$Notice.error(
                   {title: err.networkError.response.statusText,
                    desc: err.networkError.result.errors[0].message});}
           self.reset();
           self.loading = false
           self.addCityDialog = false;
       })
    },
    onEditCity(cityData){
      this.cityForm.id = cityData.id;
      this.cityForm.city = cityData.city;
      this.cityForm.shortCode = cityData.shortCode;
      this.cityForm.state = cityData.state;
      this.cityForm.country = cityData.country;
      this.editMode = true;
      this.addCityDialog = true;
    },
   modifyCity(){
       this.$refs['cityForm'].validate((valid) => {
           if (valid) {
               this.updateCity();
           }
       })
   },
   async updateCity(){
       let self = this;
       this.$apollo.mutate({
           mutation: this.mutation_UPDATE_CITY,
           variables: {
               cityId: this.cityForm.id,
               city: this.cityForm.city,
               shortCode: this.cityForm.shortCode.toUpperCase(),
               state: this.cityForm.state,
               country: this.cityForm.country
           }
       }).then(function(response){
           self.$Message.success('City updated successfully!');
           self.reset();
           self.addCityDialog = false;
       }).catch(function(err){
           if(err.networkError.result.errors && err.networkError.result.errors.length){
               self.$Notice.error(
                   {title: err.networkError.response.statusText,
                       desc: err.networkError.result.errors[0].message});}
           self.reset();
           self.addCityDialog = false;
       })
   },
   onDeleteCity(cityId){
       this.$Modal.confirm({
           title: 'Confirmation',
           content: '<p>Are You sure want to delete City ?</p>',
           loading: true,
           onOk: () => {
               this.deleteCity(cityId, this.$Modal)
           }
       });
   },
   deleteCity(cityId, callback) {
       let self = this;
        this.$apollo.mutate({
           mutation: this.mutation_DELETE_CITY,
           variables: { cityId: cityId }
       }).then(function(response){
           callback.remove();
           self.$Message.success('City deleted successfully!');
       }).catch(function(err){
           if(err.networkError.result.errors && err.networkError.result.errors.length){
               self.$Notice.error(
                   {title: err.networkError.response.statusText,
                     desc: err.networkError.result.errors[0].message});}
           callback.remove();
       })
   }
 }
}
</script>

<style scoped>
 /deep/ .ivu-modal-close{
    visibility: hidden;
}
 /deep/ .code-uppercase > input{
    text-transform: uppercase;
}
 /deep/ .ivu-table td {
     border-bottom: 0px;
 }
 /deep/ .ivu-table th {
     border-bottom: 0px;
 }
 /deep/ .ivu-table-wrapper {
     position: unset !important;
     border: 0px ;
 }
</style>